<script setup lang="ts">
import { experiences } from '../../data/experience'
import Timeline from '../experience/Timeline.vue'
import Skills from './Skills.vue'
import { revealDirective } from '../../composables/useReveal'

defineOptions({ directives: { reveal: revealDirective } })
</script>

<template>
  <section id="experience" class="section cv-auto">
    <div class="wrap">
      <!--
        The old tab switcher hid half this section behind a click. Both halves
        are short enough to simply read in sequence.
      -->
      <div class="section-head" v-reveal>
        <h2 class="display display-3">Experience</h2>
        <p class="eyebrow">2019 → now</p>
      </div>

      <Timeline :experiences="experiences" class="block" />

      <div class="section-head stack-head" v-reveal>
        <h2 class="display display-3">Stack</h2>
        <p class="eyebrow">Self-assessed</p>
      </div>

      <Skills />
    </div>
  </section>
</template>

<style scoped>
.section-head {
  margin-bottom: clamp(1.5rem, 4vw, 2.5rem);
}
.stack-head {
  margin-top: clamp(3rem, 8vw, 5.5rem);
}
</style>
